module.exports = __webpack_public_path__ + "img/login-title.a2e6e21d.png";